<template>
  <v-layout
      row
     
      :class="[
        'conversation-message',
        {
          'conversation-message--mine': isMyMessage,
          'conversation-message--failed': message.isFailed,
        },
      ]">
    <v-flex class="conversation-message__image-container conversation-message__item">
      <v-avatar size="36">
        <v-img
            :src="profileImage.url || ''"
            @error="profileImage.url = profileImage.fallback">
        </v-img>
      </v-avatar>
    </v-flex>
    <v-flex class="conversation-message__item">
      <v-layout column class="conversation-message__container">
        <div>
          <v-flex>
            <h5>{{author.name}}</h5>
            <span>{{timestamp}}</span>
          </v-flex>
          <span>{{author.primaryChapter}}</span>
        </div>
        <p class="conversation-message__message-text">{{message.messageText}}</p>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { storeGetters } from '../../../store/storeGetters.constant';
import { mapGetters } from 'vuex';
import { getShortMonthName } from "@/common/utils/dateTime";

export default {
  name: 'ConversationMessage',
  props: {
    message: {
      type: Object,
      required: true,
    },
    author: {
      type: Object,
      required: true,
    },
    displayDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('messenger', {
      messengerUsername: storeGetters.messengerUsername,
    }),
    profileImage() {
      return {
        url: this.author.profileImageUrl,
        fallback: this.author.fallbackProfileImageUrl,
      };
    },
    isMyMessage() {
      return this.author.id === this.messengerUsername;
    },
    timestamp() {
      const d = new Date(this.message.ts);
      const h = d.getHours();
      const m = d.getMinutes();
      const date = d.getDate();
      const mon = getShortMonthName(d.getMonth());
      const year = d.getFullYear();
      const dateLabel = this.displayDate ? `${date} ${mon} ${year}` : "";
      const two = n => ((s => s.slice(s.length - 2))(`00${n}`));
      return `${two(h)}:${two(m)} ${dateLabel}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../common/styles/_colors.scss';
@import '../../../common/styles/_responsive.scss';

    .conversation-message {
      &__item {
        flex: 0 1 auto !important;
      }

      &__image-container {
          margin-right: 10px;
      }

    &--mine {
        margin-left: 56px;

      @include breakpoint(sm) {
        margin-left: 20px;
      }

         .conversation-message__container{
             background: rgba($ypo-blue, 0.1);
         }

    
    }
    &__container{
        background: $white;
        padding: 5px 10px;
        border-radius: 4px;
        margin-bottom: 10px;
        margin-right: 10px;
    p{
        margin-bottom: 0px;
        line-height: normal;
        display: block;
        margin-top: 5px;
        font-size: 12px;
        word-break: break-word;
    }
    span {
        font-size: 12px;
        line-height: normal;
        display: block;
        color: $ypo-gray;   
    }
    h5 {
        font-weight: 600;
        line-height: normal;
        color: rgba($ypo-blue, 0.8)

    }
    }
    }
</style>
